document.addEventListener('DOMContentLoaded', () => {
    const popup = document.getElementById('popup');
    const closeBtn = document.getElementById('popup-close');
    const localStorageKey = 'popupClosed';
    const hideDurationDays = 7;

    if (!popup || !closeBtn) {
        return;
    }

    const wasClosed = () => {
        const closedTimestamp = localStorage.getItem(localStorageKey);
        if (!closedTimestamp) return false;
        const closedDate = new Date(parseInt(closedTimestamp, 10));
        const now = new Date();
        const diffDays = (now - closedDate) / (1000 * 60 * 60 * 24);
        return diffDays < hideDurationDays;
    };

    const showPopup = () => {
        if (!wasClosed()) {
            popup.classList.add('show');
        }
    };

    const closePopup = () => {
        popup.classList.remove('show');
        setTimeout(() => {
            localStorage.setItem(localStorageKey, Date.now().toString());
        }, 400); // matches the CSS transition duration
    };

    closeBtn.addEventListener('click', closePopup);

    window.addEventListener('load', () => {
        setTimeout(showPopup, 5000);
    });
});
